export function positionSelectPanel(panel, select) {
  let frame = null
  panel._appSelectOwner = select.$el
  const position = () => {
    frame = null
    const toggle = select.$refs.toggle
    if (!toggle?.isConnected) return
    const rect = toggle.getBoundingClientRect()
    const width = Math.min(rect.width, Math.max(0, document.documentElement.clientWidth - 16))
    const height = Math.min(360, Math.max(80, panel.scrollHeight))
    const below = innerHeight - rect.bottom - 8, above = rect.top - 8
    const up = below < height && above > below
    const available = Math.max(80, Math.min(360, up ? above : below, innerHeight - 16))
    const actualHeight = Math.min(height, available)
    const left = Math.max(8, Math.min(rect.left, innerWidth - width - 8))
    const top = Math.max(8, Math.min(up ? rect.top - actualHeight - 5 : rect.bottom + 5, innerHeight - actualHeight - 8))
    let layer = 1060
    for (let node = select.$el; node && node !== document.body; node = node.parentElement) {
      const z = Number(getComputedStyle(node).zIndex)
      if (Number.isFinite(z)) layer = Math.max(layer, z + 10)
    }
    Object.assign(panel.style, { position: 'absolute', width: width + 'px', left: scrollX + left + 'px', top: scrollY + top + 'px', zIndex: String(layer) })
    panel.style.setProperty('max-height', available + 'px', 'important')
    panel.style.setProperty('--app-select-list-height', Math.max(28, available - 16) + 'px')
    panel.classList.toggle('app-select-panel-above', up)
    panel.style.setProperty('--app-select-theme', getComputedStyle(select.$el).getPropertyValue('--color-theme').trim() || '#2563eb')
  }
  const schedule = () => { if (frame != null) cancelAnimationFrame(frame); frame = requestAnimationFrame(position) }
  position()
  const observer = new ResizeObserver(schedule)
  observer.observe(panel)
  if (select.$refs.dropdownMenu) observer.observe(select.$refs.dropdownMenu)
  window.addEventListener('resize', schedule)
  window.addEventListener('scroll', schedule, true)
  return () => { observer.disconnect(); if (frame != null) cancelAnimationFrame(frame); window.removeEventListener('resize', schedule); window.removeEventListener('scroll', schedule, true); delete panel._appSelectOwner }
}
